import { Link, useLocation } from 'wouter'
import { useOfferStore, selectFilteredCount, selectTotalCount, selectHasActiveFilters } from '@store/offerStore'
import styles from './StatsBar.module.css'

const VIEW_OPTIONS = [
  { path: '/', icon: '▦', label: 'Overzicht' },
  { path: '/compare', icon: '📊', label: 'Vergelijken' },
  { path: '/health', icon: '🩺', label: 'Health' },
]

export function StatsBar({ layoutClassName = undefined }) {
  const loading = useOfferStore(s => s.loading)
  const filteredCount = useOfferStore(selectFilteredCount)
  const totalCount = useOfferStore(selectTotalCount)
  const hasActiveFilters = useOfferStore(selectHasActiveFilters)
  const [location] = useLocation()

  const countSuffix = hasActiveFilters
    ? ` van ${totalCount} bio aanbiedingen`
    : ' bio aanbiedingen deze week'

  const countContent = loading
    ? 'Laden...'
    : <><strong className={styles.countNumber}>{filteredCount}</strong>{countSuffix}</>

  return (
    <div className={`${styles.component} ${layoutClassName || ''}`}>
      <span className={styles.count}>
        {countContent}
      </span>

      <div className={styles.viewToggle}>
        {VIEW_OPTIONS.map(({ path, icon, label }) => {
          const isActive = path === '/'
            ? location === '/'
            : location.startsWith(path)

          return (
            <Link
              key={path}
              href={path}
              className={`${styles.viewBtn} ${isActive ? styles.viewBtnActive : ''}`}
            >
              {icon} {label}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
